import type { ColumnDef } from '@tanstack/react-table';
import { DateTime } from 'luxon';
import type { ProjectWithDataRequests } from '~/common/types';
import { dateTimeSortingFn } from '~/components2/Table';

export const columns: ColumnDef<ProjectWithDataRequests>[] = [
  {
    id: 'project.name',
    header: 'Project Name',
    size: 150,
    accessorKey: 'name',
  },
  {
    id: 'organization.name',
    header: 'Organization',
    accessorKey: 'organization.name',
    size: 150,
  },
  {
    id: 'projectManager.name',
    header: 'Project Manager',
    accessorFn: (req) => {
      const u = req.projectManager;
      const val = `${u.name} (${u.email})` || '';
      return val;
    },
    size: 150,
  },
  {
    id: 'activeRequestsCount',
    header: 'Active Requests',
    accessorKey: 'activeRequestsCount',
    size: 100,
  },
  {
    id: 'project.createdAt',
    header: 'Created At',
    size: 100,
    sortingFn: (a, b) => dateTimeSortingFn(a, b, 'createdAt'),
    accessorFn: (req) => {
      const date = req.createdAt instanceof DateTime ? req.createdAt.toJSDate() : new Date(req.createdAt);
      return date.toLocaleDateString();
    },
  },
  {
    id: 'activeIncompleteRequestsCount',
    header: 'Active Incomplete Requests',
    accessorKey: 'activeIncompleteRequestsCount',
    size: 100,
  },
  {
    id: 'assignedTo.name',
    header: 'Assigned To',
    size: 150,
    accessorFn: (req) => {
      const users = req.assignedTo;
      const uniqueNames = [...new Set(users.map((u) => u.name))];
      return uniqueNames.join(', ') || '';
    },
  },
  {
    id: 'project.projectId',
    header: 'Project ID',
    accessorKey: 'projectId',
    size: 100,
  },
  {
    id: 'organization.isInternal',
    header: 'Internal Org',
    accessorFn: ({ isInternal }) => isInternal,
  },
];
